import { Form, Input, Tooltip } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DraggableModal } from '../../../../../components/DraggableModal'
import { EntVetProduct } from '../../../../../models/handBooks/vetProduct'
import SelectVeterinaryProductCategory from '../../../../../components/selects/SelectVeterinaryProductCategory'
import i18n from 'i18next'

enum FormField {
	categoryId,
	nameRu,
	nameKy,
	category,
}

interface IProps {
	show: boolean
	typeVeterinaryProduct: EntVetProduct
	onHide: () => void
	onSubmit: (pos: EntVetProduct) => Promise<boolean>
}

export const AddTypeVeterinaryProductModal = (props: IProps) => {
	const { t } = useTranslation()
	const [form] = useForm()
	const [loading, setLoading] = useState<boolean>(false)

	useEffect(() => {
		if (props.show) setFieldsFromEntity()
	}, [props.show])

	const setFieldsFromEntity = (): void => {
		form.setFields([
			{
				name: FormField.categoryId,
				value: props.typeVeterinaryProduct.category?.id,
			},
			{ name: FormField.nameKy, value: props.typeVeterinaryProduct.nameKy },
			{ name: FormField.nameRu, value: props.typeVeterinaryProduct.nameRu },
		])
	}

	const setEntityFromFields = (): EntVetProduct => {
		let typeVeterinaryProduct = _.cloneDeep(props.typeVeterinaryProduct)
		typeVeterinaryProduct.categoryId = form.getFieldValue(FormField.categoryId)
		typeVeterinaryProduct.nameKy = form.getFieldValue(FormField.nameKy)
		typeVeterinaryProduct.nameRu = form.getFieldValue(FormField.nameRu)
		return typeVeterinaryProduct
	}

	const handleSubmit = async () => {
		setLoading(true)
		try {
			await form.validateFields()
			const data = setEntityFromFields()
			const result = await props.onSubmit(data)

			if (result) props.onHide()
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
			<DraggableModal
				title={
					props.typeVeterinaryProduct.id === null
						? t('handbooks.types_of_products.Add Product')
						: t('handbooks.types_of_products.Edit Product Type')
				}
				visible={props.show}
				onCancel={props.onHide}
				onSubmit={handleSubmit}
				submitLoading={loading}
			>
				<Form initialValues={{ remember: true }} autoComplete='off' layout='vertical' form={form}>
					<Form.Item
						label={t('general.nameKy')}
						name={FormField.nameKy}
						rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
					>
						<Input autoComplete='off' />
					</Form.Item>
					<Form.Item
						label={t('general.nameRu')}
						name={FormField.nameRu}
						rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
					>
						<Input autoComplete='off' />
					</Form.Item>
					<Form.Item
						label={t('handbooks.types_of_products.Product Category')}
						name={FormField.categoryId}
						rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
					>
						<SelectVeterinaryProductCategory />
					</Form.Item>
				</Form>
			</DraggableModal>
		</>
	)
}
